Vendd.Scripts.load(function () {

    Vendd.MessageBus.subscribe(Vendd.Product.Messages.BindControl, 'product-details-version-selector', function (envelope) {

        var $context = envelope.message.data.context,
            $control = $('.x-product-details-version-selector', $context);

        if ($control.length < 1)
            return;

        $.each($control, function (i, control) {
            var $item = $(control);

            if ($item.data('type') === 'list') {

                $item.on('click', '.js-selector', function (e) {

                    var $this = $(this);

                    if ($this.hasClass('selected'))
                        return;

                    $this.addClass('selected');

                    var id = $this.data('value');

                    deleteSpinnerInstances();

                    Vendd.MessageBus.publishAsync(control, new Vendd.Product.Messages.SetSelected({ id: id, visitorInitiated: true }));

                    if ($(this).closest('.x-product-details-version-selector').hasClass('color'))
                        reInitLazyProductLists($this.data('version-id'));
                });
            };

            if ($item.data('type') === 'dropdown') {

                $item.on('change', '.js-selector', function (e) {

                    var $this = $(this);

                    var id = $this.val();

                    $item.addClass('x-loading');

                    deleteSpinnerInstances();

                    Vendd.MessageBus.publishAsync(control, new Vendd.Product.Messages.SetSelected({ id: id, visitorInitiated: true }));

                    //save the selected version in global variable
                    //in order to use it in pdLenses.js
                    if ($(this).closest('.x-product-details-version-selector').parent().hasClass('x-versions')) {
                        initialVersionHasValue = true;
                        selectedVersion = "initial";
                    } else if ($(this).closest('.x-product-details-version-selector').parent().hasClass('x-duplicated-versions')) {
                        duplicatedVersionHasValue = true;
                        selectedVersion = "duplicated";
                    }

                    if ($(this).closest('.x-product-details-version-selector').hasClass('color'))
                        reInitLazyProductLists($this.data('version-id'));
                });

                if (!isTouch()) {
                    $('.js-selector', $item).sSelect().change(function () {
                        var $this = $(this);

                        var id = $this.val();

                        $item.addClass('x-loading');

                        deleteSpinnerInstances();

                        Vendd.MessageBus.publishAsync(control, new Vendd.Product.Messages.SetSelected({ id: id, visitorInitiated: true }));

                        //save the selected version in global variable
                        //in order to use it in pdLenses.js
                        if ($(this).closest('.x-product-details-version-selector').parent().hasClass('x-versions')) {
                            initialVersionHasValue = true;
                            selectedVersion = "initial";
                        } else if ($(this).closest('.x-product-details-version-selector').parent().hasClass('x-duplicated-versions')) {
                            duplicatedVersionHasValue = true;
                            selectedVersion = "duplicated";
                        }

                        if ($(this).closest('.x-product-details-version-selector').hasClass('color'))
                            reInitLazyProductLists($this.data('version-id'));
                    });
                }
            };
	    
	        if ($item.data('type') === 'sku-table') {
             
                var $tableSkus = $('.js-sku-quantity-selector', $item);

                $tableSkus.each(function (index, tableSku) {
                    var $tableSku, $box, $addToCartBtn, $incr,
                        $decr, $qty, quanta, max, min;

                    $tableSku = $(tableSku),
                    $box = $tableSku.closest(".sku-product-box"),
                    quanta = $tableSku.data('quanta') || 1,
                    max = $tableSku.data('max') || 100000,
                    min = $tableSku.data('min') || 1,

                    
                    $qty = $('.js-qty-input', $box),
                    $incr = $('.js-qty-incr', $tableSku),
                    $decr = $('.js-qty-decr', $tableSku);
                    
                    if ($tableSku.hasClass('disabled')) return;

                    $incr.on('click', function () {
                        var quantity = stringToNumber($qty.val());
                     
                        if ($incr.hasClass('disabled')) return;

                        if (Vendd.Helpers.isInteger(parseFloat(quanta))) {
                            quantity = parseInt(quantity) + parseInt(quanta);
                        }
                        else {
                            quantity = parseFloat(quantity) + parseFloat(quanta);
                            quantity = parseFloat(quantity).toFixed(2);
                        }

                        updateQuantitiesControl($tableSku, $qty, $incr, $decr, quantity, min, max);
                    });

                    $decr.on('click', function () {
                        var quantity = stringToNumber($qty.val());

                        if ($decr.hasClass('disabled')) return;

                        if (Vendd.Helpers.isInteger(parseFloat(quanta))) {
                            quantity = parseInt(quantity) - parseInt(quanta);
                        }
                        else {
                            quantity = parseFloat(quantity) - parseFloat(quanta);
                            quantity = parseFloat(quantity).toFixed(2);
                        }

                        updateQuantitiesControl($tableSku, $qty, $incr, $decr, quantity, min, max);
                    });

                    $qty.on('focusout', function () {
                        var quantity = stringToNumber($qty.val());

                        quantity = Math.round(quantity / quanta) * quanta; //round to nearest quanta
                        updateQuantitiesControl($tableSku, $qty, $incr, $decr, quantity, min, max);
                    });


                    $qty.on('keyup', function (e) {
                        // press enter
                        if (e.keyCode == 13) {

                            var quantity = stringToNumber($qty.val());

                            quantity = Math.round(quantity / quanta) * quanta; //round to nearest quanta
                            updateQuantitiesControl($tableSku, $qty, $incr, $decr, quantity, min, max);
                        }
                    });
                });
            };
	    
            function updateQuantitiesControl($wrapper, $qty, $incr, $decr, value, min, max) {
                value = (isNaN(value)) ? min : value;

                var $container = $wrapper.closest('.sku-product-box'),
                    $addToCartBtn = $('.js-add-sku-to-cart', $container);

                if (!$container.length > 0)
                    return;

                var $price = $('.js-unit-price', $container).html(),
                     $targetPrice = $('.js-total-price', $container),
                     total, text;
               
                if (parseFloat(value) >= parseFloat(max)) {
                    value = parseInt(max);
                    $incr.addClass('disabled');
                } else {
                    $incr.removeClass('disabled');
                }

                if (parseFloat(value) <= parseFloat(min)) {
                    value = min;
                    $decr.addClass('disabled');
                } else {
                    $decr.removeClass('disabled');
                }


                if (value == 0) {
                    // deactivate add to cart button
                    $addToCartBtn.addClass('inactive');
                } else {
                    //activate add to cart button
                    $addToCartBtn.removeClass('inactive').prev().removeClass('visible');
                }


                
                total = parseFloat(value * stringToNumber($price)).toFixed(2),
                text = numberToString(total, true);

                $targetPrice.html(text);

                $qty.val(numberToString(value, false, true));
                $qty.change();
            }

        });
    });
});
